module.exports = "/_next/static/images/MaintenanceIntegrityManagement-11b78b2fbe2c549c8d3b472fbfe2150e.webp";